import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.dokument-download';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenDokumentDownloadEffects {

    DokumentDownload$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_DOKUMENT_DOWNLOAD),
        mergeMap((x: ac.GetDokumentDownloadAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getDokumentDownload(x.dokument_id).pipe(
                map((result: any) => {
                    return new ac.GetDokumentDownloadErfolgreichAction(result, x.dokument_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetDokumentDownloadFehlerAction(error, x.dokument_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.DokumentQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.DokumentQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.DokumentQueryService);
        }
        return this.service;
    }
}
